import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-6" }
const _hoisted_3 = { class: "field col-12 lg:col-4" }
const _hoisted_4 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "text-italic" }
const _hoisted_11 = {
  key: 0,
  class: "badge status-green"
}
const _hoisted_12 = {
  key: 1,
  class: "badge status-red"
}
const _hoisted_13 = {
  key: 2,
  class: "badge status-purple"
}
const _hoisted_14 = { class: "badge status-blue" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statHandleReport.company")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statStockChart.month")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.monthDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.monthDate) = $event)),
          options: _ctx.months,
          onChange: _ctx.dataChanged,
          optionLabel: "label",
          optionValue: "date",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printReport()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "order",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("statHandleReport.handleReportInitialCount")) + ": " + _toDisplayString(_ctx.n(_ctx.handleReportInitialCount, "number0")), 1),
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(_ctx.t("statHandleReport.handleReportCount")) + ": " + _toDisplayString(_ctx.n(_ctx.handleReportCount, "number0")), 1),
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(_ctx.t("statHandleReport.handleReportPeak")) + ": " + _toDisplayString(_ctx.n(_ctx.handleReportPeak, "number0")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "date",
                  header: _ctx.t('statHandleReport.date'),
                  headerStyle: "width: 16%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.d(data[field], "shortDate")), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "type",
                  header: _ctx.t('statHandleReport.parcel'),
                  headerStyle: "width: 18%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", null, _toDisplayString(data[field] ? `${data[field].name} ${data["code"]}` : `${_ctx.t("statHandleReport.parcel")} ${data["code"]}`), 1),
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(data["companyCodes"]), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "shipment",
                  sortField: "shipment.date",
                  header: _ctx.t('statHandleReport.shipment'),
                  headerStyle: "width: 30%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field]
                  ? _ctx.t("statHandleReport.shipmentDetail", {
                      code: data[field].code,
                      date: _ctx.d(data[field].date, "shortDate"),
                      companyName: data[field].company.name,
                    })
                  : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "action",
                  header: _ctx.t('statHandleReport.action'),
                  bodyClass: "text-center",
                  headerStyle: "width: 12%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field] == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "+1"))
                      : (data[field] == -1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "-1"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.t("statHandleReport.parcelStates.unknown")), 1))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "count",
                  header: _ctx.t('statHandleReport.count'),
                  bodyClass: "text-center",
                  headerStyle: "width: 14%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.n(data[field], "number0")), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}